<app-ppp-admin-header></app-ppp-admin-header>

<div class="admin-container">
  <mat-sidenav-container>
    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
